var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnroll = function SvgEnroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8V6h8v2H5Zm0 3V9h8v2H5Zm0 3v-2h8v2H5Zm9-8V4h-2V2h2V0h2v2h2v2h-2v2h-2ZM0 18V0h11v2H2v14h14V7h2v11H0Z",
    fill: "#FFC83E"
  })));
};
export { SvgEnroll as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNSA4VjZIMTNWOEg1Wk01IDExVjlIMTNWMTFINVpNNSAxNFYxMkgxM1YxNEg1Wk0xNCA2VjRIMTJWMkgxNFYwSDE2VjJIMThWNEgxNlY2SDE0Wk0wIDE4VjBIMTFWMkgyVjE2SDE2VjdIMThWMThIMFoiIGZpbGw9IiNGRkM4M0UiLz4KPC9zdmc+";